<vdr-card [title]="'Version'">
  {{ version }}
</vdr-card>
